import { deleteCoreDataSecurityMonitorByIdSlice } from './delete';
import { muteCoreDataSecurityMonitorsSlice } from './mute';
import { patchCoreDataSecurityMonitorByIdSlice } from './patch';
import { subscribeCoreDataSecurityMonitorByIdSlice } from './subscribe';

export const { requestDeleteCoreDataSecurityMonitorsById, resetDeleteCoreDataSecurityMonitorsById } =
    deleteCoreDataSecurityMonitorByIdSlice.asyncActionCreators;

export const { requestPatchMuteCoreDataSecurityMonitorsById, resetPatchMuteCoreDataSecurityMonitorsById } =
    muteCoreDataSecurityMonitorsSlice.asyncActionCreators;

export const { requestPatchCoreDataSecurityMonitorsById, resetPatchCoreDataSecurityMonitorsById } =
    patchCoreDataSecurityMonitorByIdSlice.asyncActionCreators;

export const { requestPostSubscribeCoreDataSecurityMonitorsById, resetPostSubscribeCoreDataSecurityMonitorsById } =
    subscribeCoreDataSecurityMonitorByIdSlice.asyncActionCreators;
